import type { Concept } from '@semantical/modules/vocabulary';

/**
 * Extract local name from a URI (after # or last /).
 * Underscores are replaced with spaces for display.
 */
export function extractLocalName(uri: string): string {
    const hashIndex = uri.lastIndexOf('#');
    if (hashIndex !== -1) return uri.substring(hashIndex + 1).replace(/_/g, ' ');
    const slashIndex = uri.lastIndexOf('/');
    if (slashIndex !== -1) return uri.substring(slashIndex + 1).replace(/_/g, ' ');
    return uri;
}

/**
 * Normalize IRI by removing trailing # or /.
 */
export function normalizeIri(iri: string): string {
    return iri.replace(/[#/]$/, '');
}

/**
 * Slugify a name for use in a URI segment.
 * Trims whitespace, replaces spaces with underscores, and URI-encodes.
 */
export function slugifyForUriSegment(name: string): string {
    return encodeURIComponent(name.trim().replace(/\s+/g, '_'));
}

/**
 * Infer base URI from existing concepts.
 * Looks at the first concept's URI and extracts the namespace portion.
 */
export function inferBaseUri(concepts: Concept[]): string {
    if (concepts.length > 0) {
        const sample = concepts[0].uri;
        // If contains '#', keep up to '#'
        const hashIdx = sample.lastIndexOf('#');
        if (hashIdx >= 0) return sample.substring(0, hashIdx + 1);
        // Else use up to last '/'
        const slashIdx = sample.lastIndexOf('/');
        if (slashIdx >= 0) return sample.substring(0, slashIdx + 1);
    }
    return "http://example.org/automobile/";
}
